<template>
    <div class="signup">
        <div class="row">
            <div class="col logo-header">
                <router-link to="/">
                    <img src="../assets/images/logo.png" width="111px">
                </router-link>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <h3>{{$t('signup.title')}}</h3>
            </div>
        </div>
        <div class="row justify-content-center">
            <div class="col-8 col-sm-4">
                <b-form-group id="email-form-group"
                              class="o-label"
                              label="Email"
                              label-for="email-input">
                    <b-form-input id="email-input"
                                  class="o-form"
                                  type="text"
                                  v-model="email"
                                  required
                                  placeholder="Email">
                    </b-form-input>
                </b-form-group>
            </div>
        </div>
        <div class="row justify-content-center">
            <div class="col col-8 col-sm-4">
                <b-form-group id="password-form-group"
                              class="o-label"
                              :label="$t('signup.password')"
                              label-for="password-input">
                    <b-form-input id="password-input"
                                  class="o-form"
                                  type="password"
                                  v-model="password"
                                  required
                                  :placeholder="$t('signup.password')">
                    </b-form-input>
                </b-form-group>
            </div>
        </div>
        <div class="row justify-content-center">
            <div class="col col-8 col-sm-4">
                <b-button class="o-button"
                          v-on:click="signup">
                    {{$t('signup.registerButton')}}
                </b-button>
            </div>
        </div>
        <div class="row justify-content-center">
            <div class="col col-8 col-sm-4 links">
                <div>
                    {{$t('signup.alreadyRegistered')}}
                    <router-link to="/login">{{$t('signup.loginAction')}}</router-link>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <div class="language-selection">
                    <h6>
                        <a href="#" v-on:click="switchLang('de')">Deutsch</a> |
                        <a href="#" v-on:click="switchLang('en')">English</a>
                    </h6>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapActions} from 'vuex'
    import {AUTH_ACTION_SIGN_UP, AUTH_NAMESPACE} from '../store/modules/auth-types'
    import i18n from '../assets/i18n/lang'

    export default {
        name: 'Signup',
        metaInfo () { return { title: i18n.t('signup.meta') } },
        props: {
            config: ''
        },
        data: function () {
            return {
                email: '',
                password: ''
            }
        },
        methods: {
            ...mapActions(AUTH_NAMESPACE, {
                signUp: AUTH_ACTION_SIGN_UP
            }),
            signup: function () {
                this.signUp({email: this.email, password: this.password})
            },
            switchLang: function (lang) {
                this.$i18n.locale = lang
            }
        }
    }
</script>

<style lang="scss" scoped>
    .links {
        padding-top: 20px;
        white-space: nowrap;
        text-align: center;
        font-size: 10pt;
    }
</style>



// WEBPACK FOOTER //
// src/components/SignupComponent.vue